import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlaceService {

  constructor(private httpClient: HttpClient) { }

  public getCities(query: string, organization: number): Observable<{ city: string, placeId: string }[]> {
    return this.httpClient.get<{ city: string, placeId: string }[]>(`/api/media/places/cities`, { params: new HttpParams({ fromObject: { query, organization } }) });
  }

  public place(placeId: string): Observable<{ city: string, lat: number, long: number }> {
    return this.httpClient.get<{ city: string, lat: number, long: number }>(`/api/media/places/place`, { params: new HttpParams({ fromObject: { place_id:placeId } }) });
  }
}
